<template>
  <div id="budgetMax">
    <b-form-input
      v-currency="{
        currency: 'EUR',
        precision: 0,
        distractionFree: false,
        locale: 'fr',
      }"
      v-model="budgetMax"
      :class="{ 'border-bottom-blue  text-blue': isBudgetMaxSet && isNotEmpty }"
      ref="input"
      class="box-shadow-none"
      placeholder="900 000 €"
      debounce="1000"
      :autofocus="this.$router.currentRoute.name != 'dashboard'"
    ></b-form-input>
    <!--  <b-currency-input v-model="budgetMax" /> -->
  </div>
</template>

<script>
import { CurrencyDirective } from "vue-currency-input";
import { mapState, mapGetters } from "vuex";
export default {  
  /* data() {
    return {
      budgetMax: this.$store.state.userSearch.budgetMax,
    };
  }, */
  computed: {
    ...mapGetters(["isBudgetMaxSet"]),
    ...mapState(["isSearchLoaded"]),

    budgetMax: {
      get() {
        return this.$store.state.userSearch.budgetMax;
      },
      set(value) {
        if (value) {
          let parsedValue = parseInt(value.replace(/[^0-9]/g, ""));
          this.$store.commit("SET_BUDGET_MAX", parsedValue);
        } else {
          this.$store.commit("SET_BUDGET_MAX", null);
        }
      },
    },
    isNotEmpty() {
      return this.$store.state.userSearch.budgetMax > 0 ? true : false;
    },
  },
  methods: {
    focusAndBlur() {
      this.$refs.input.$el.focus({
        preventScroll: true,
      });
      this.$refs.input.$el.blur();
    },
  },
  mounted() {
    if (this.$router.currentRoute.name == "dashboard") this.focusAndBlur();
  },

  directives: { currency: CurrencyDirective },
};
</script>

<style lang="scss" scoped>
@import "@/styles/forms.scss";
input {
  width: 9rem;
  margin-left: 1rem;
  font-size: 1.2rem;
  font-weight: 600;
}
</style>
